module.exports = __webpack_public_path__ + "img/507-42dfb3.png";